module.exports = {"id":"240359","name":"Omar Alderete","rating":"73","photo":"./data/images/photos/3/240359.png","club":{"name":"G. La Plata","logo":"./data/images/clubs/G.LaPlata.png"},"positions":["DC","DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OmarAlderete0.json
// module id = 3275
// module chunks = 0